const detectOs = {
    getUserAgent: () => {
        return navigator.userAgent;
    },
    getPlatform: () => {
        return navigator.platform;
    },
    isIos: () => {
        return /iPhone|iPad|iPod/.test(detectOs.getPlatform());
    },
    isAndroid: () => {
        return /Android/.test(detectOs.getUserAgent());
    },
    isBlackBerry: () => {
        return /BlackBerry/.test(detectOs.getPlatform());
    },
    isMac: () => {
        return /Mac/.test(detectOs.getPlatform());
    },
    isWindows: () => {
        return /Win/.test(detectOs.getUserAgent());
    },
    isLinux: () => {
        return /Linux/.test(detectOs.getPlatform()) && !detectOs.isAndroid();
    },
    get: () => {
        if (detectOs.isIos()) return 'iOS';
        if (detectOs.isAndroid()) return 'Android';
        if (detectOs.isBlackBerry()) return 'BlackBerry';
        if (detectOs.isMac()) return 'Mac';
        if (detectOs.isWindows()) return 'Windows';
        if (detectOs.isLinux()) return 'Linux';
        return 'Unknown';
    },
    isMobile: () =>{
        return detectOs.isIos() || detectOs.isAndroid();
    }
};

module.exports = detectOs;